const sections = document.querySelectorAll('.card-fan');
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const metrics = new WeakMap();

function setContainerClasses(containers, activeIndex) {
  containers.forEach((container, i) => {
    container.classList.toggle('is-visible', i === activeIndex);
    container.classList.toggle('is-before-scroll', i < activeIndex);
    container.classList.toggle('is-after-scroll', i > activeIndex);
  });
}

function lastCardInset(cards) {
  const last =
    cards.querySelector('.photo-card, .card:last-child') ||
    cards.lastElementChild;
  return last ? last.offsetWidth : 340;
}

function measure(section, cards) {
  const vw = window.innerWidth;
  const vh = window.innerHeight;
  const inset = lastCardInset(cards);
  const fullTravel = cards.scrollWidth + vw;
  // Last card centre at the viewport midpoint — remaining strip on screen
  const remainingAtUnpin = vw / 2 + inset / 2;
  const edgeTravel = Math.max(1, fullTravel - remainingAtUnpin);

  // Pin until the last card passes halfway. The rest of the travel
  // (off-screen) happens while the section scrolls away after unpinning.
  section.style.setProperty(
    '--card-fan-height',
    `${Math.max(vh + 1, edgeTravel)}px`
  );
  metrics.set(section, { pEdge: edgeTravel / fullTravel });
}

function progressThroughSection(rect, vh, pEdge) {
  // 0: section top reaches the bottom of the viewport (approaching)
  // pEdge: section unpins — last card passing the viewport midpoint
  // 1: section has left the viewport — strip fully off the left
  const start = vh;
  const unpinTop = vh - rect.height;
  const goneTop = -rect.height;

  if (rect.top >= start) return 0;
  if (rect.top <= goneTop) return 1;

  if (rect.top > unpinTop) {
    const range = start - unpinTop;
    return ((start - rect.top) / range) * pEdge;
  }

  const range = unpinTop - goneTop;
  const t = (unpinTop - rect.top) / range;
  return pEdge + t * (1 - pEdge);
}

function handleScroll() {
  const vh = window.innerHeight;

  sections.forEach((section) => {
    const cards = section.querySelector('.card-fan__cards');
    const containers = section.querySelectorAll('.card-fan__container');
    const containerCount = containers.length;
    const rect = section.getBoundingClientRect();
    const pEdge = metrics.get(section)?.pEdge ?? 1;
    const progress = progressThroughSection(rect, vh, pEdge);

    if (rect.top > 0) {
      section.classList.add('is-before-viewport');
      section.classList.remove('is-in-viewport', 'is-after-viewport');
      setContainerClasses(containers, 0);
    } else if (rect.bottom > vh) {
      section.classList.add('is-in-viewport');
      section.classList.remove('is-before-viewport', 'is-after-viewport');
      const activeIndex =
        containerCount > 0
          ? Math.min(Math.floor(progress * containerCount), containerCount - 1)
          : 0;
      setContainerClasses(containers, activeIndex);
    } else {
      section.classList.add('is-after-viewport');
      section.classList.remove('is-before-viewport', 'is-in-viewport');
      setContainerClasses(containers, containerCount - 1);
    }

    if (!cards || reducedMotion.matches) return;

    cards.style.setProperty('--card-fan-progress', progress.toFixed(4));
  });
}

function handleResize() {
  if (reducedMotion.matches) return;

  sections.forEach((section) => {
    const cards = section.querySelector('.card-fan__cards');
    if (cards) measure(section, cards);
  });

  handleScroll();
}

let ticking = false;
function onScroll() {
  if (ticking) return;
  ticking = true;
  window.requestAnimationFrame(() => {
    handleScroll();
    ticking = false;
  });
}

window.addEventListener('scroll', onScroll, { passive: true });
window.addEventListener('resize', handleResize);
reducedMotion.addEventListener('change', handleResize);
handleResize();
